import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PublicRoute = ({ children, restricted }: { children: React.JSX.Element; restricted?: boolean }) => {
  const { data = {} } = useSelector((state: any) => state.user);
  // restricted = false meaning public route
  // restricted = true meaning restricted route
  return data.access_token && restricted ? <Navigate to="/" replace /> : children;
};

export default PublicRoute;